export const INBOUNDDB = 'INBOUNDDB'; // inbounddb objects
export const UNIFIED = 'UNIFIED'; // unified analytics
export const CUSTOM = 'CUSTOM'; // lets define this so we know whats weird